import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { ToasterService } from '@purespectrum1/ui/toaster-service';
import { ModalService } from '@purespectrum1/ui/modal';

import { Subscription } from 'rxjs';

import { BuyerService } from '../../shared/services/buyer/buyer.service';
import { notifyMessage } from '../../shared/constants/notify-message';

import { SubscribeEmailModalComponent } from './subscribe-email-modal/subscribe-email-modal.component';

import { CustomizeReportModalComponent } from './customize-report-modal/customize-report-modal.component';
import { AuthService } from '../../shared/services/auth/auth.service';

@Component({
  selector: 'ps-ui-manage-report',
  templateUrl: './manage-report.component.html',
  styleUrls: ['./manage-report.component.css'],
})
export class ManageReportComponent implements OnDestroy, OnInit {
  @Input() surveyId!: number | undefined;
  @Input() isServiceBuyer!: boolean;
  private _subscription: Subscription = new Subscription();

  buttonDisabled: boolean = false;
  csButtonDisabled: boolean = false;
  includeTestTransactions: boolean = false;
  public showDynamicReportsOptions = false;
  public downloadSupplierSummaryDisabled = false;
  isProd: boolean = false;

  constructor(
    private _modal: ModalService,
    private _toastr: ToasterService,
    private _buyerService: BuyerService,
    private _authService: AuthService
  ) {}

  ngOnInit(): void {
    this.setUpInitialFlags();
  }

  setUpInitialFlags(): void {
    this.showDynamicReportsOptions =
      this._authService.buyerConfig!.enableDynamicReports ||
      this._authService.userType === 'operator';
  }

  downloadTransactionReport() {
    this.buttonDisabled = true;
    this._subscription.add(
      this._buyerService
        .downloadTransactionReport(this.surveyId, this.includeTestTransactions)
        .subscribe(
          () => {
            this.buttonDisabled = false;
          },
          () => {
            this.buttonDisabled = false;
            this._toastr.error(
              notifyMessage.errorMessage.DOWNLOAD_REPORT_ERROR
            );
          }
        )
    );
  }

  openCloumnsPreferenceModal() {
    this._modal.open(CustomizeReportModalComponent, {
      height: '80%',
      width: '80%',
    });
  }

  downloadCSTransactionReport() {
    this.csButtonDisabled = true;

    this._subscription.add(
      this._buyerService.downloadCSTransactionReport(this.surveyId).subscribe(
        () => {
          this.csButtonDisabled = false;
        },
        () => {
          this.csButtonDisabled = false;
          this._toastr.error(notifyMessage.errorMessage.DOWNLOAD_REPORT_ERROR);
        }
      )
    );
  }

  openSubscribeEmailModal() {
    this._modal.open(SubscribeEmailModalComponent, {
      height: '70%',
      width: '80%',
      data: {
        surveyId: this.surveyId,
      },
    });
  }

  downloadSupplierSummaryReport() {
    this.downloadSupplierSummaryDisabled = true;
    this._subscription.add(
      this._buyerService.downloadSupplierSummaryReport(this.surveyId).subscribe(
        () => {
          this.downloadSupplierSummaryDisabled = false;
        },
        () => {
          this.downloadSupplierSummaryDisabled = false;
          this._toastr.error(notifyMessage.errorMessage.DOWNLOAD_REPORT_ERROR);
        }
      )
    );
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }
}
